// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe[data-v-01670ee5]{width:100%;height:calc(100vh - var(--header-height));margin-top:var(--header-height);position:absolute}`, "",{"version":3,"sources":["webpack://./src/views/PDFView.vue"],"names":[],"mappings":"AACA,wBACC,UAAA,CACA,yCAAA,CACA,+BAAA,CACA,iBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
